import { Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { HelpButtonComponent } from './components/help-button/help-button.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { SearchButtonComponent } from "./components/search-button/search-button.component";
import { MatButtonModule } from '@angular/material/button';
import { FeatureService } from './services/feature.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FooterComponent, MatToolbarModule, MatIconModule, RouterLinkActive, MatMenuModule, RouterLink, MatSidenavModule, MatListModule,
    HelpButtonComponent, AvatarComponent, SearchButtonComponent, MatButtonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
constructor(
    public featureService: FeatureService
  ) {
    this.featureService.initFeatureManagement();
  }
}
